import { Box, Card, CardBody, Heading, Text, VStack } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import cardBg from '../../../assets/cardBg.svg';
import { AvailableIcon, Icon } from 'src/components/atoms/Icon';
import { imageZoomSx } from 'src/features/MP/utils/imageZoomSx';

type GettingStartedCardAltProps = {
  title: string;
  description: React.ReactNode | string;
  icon: AvailableIcon;
  href?: string;
  onClick?: () => void;
};

export const GettingStartedCardAlt: React.FC<GettingStartedCardAltProps> = ({
  title,
  description,
  icon,
  href,
  onClick,
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (href) {
      navigate(href);
    }
  };

  return (
    <Card
      maxW="xxl"
      overflow="hidden"
      borderRadius="xl"
      boxShadow="lg"
      bg="white"
      cursor="pointer"
      onClick={handleClick}>
      <Box position="relative" height="240px" overflow="hidden">
        <Box
          position="absolute"
          inset={0}
          backgroundImage={`url(${cardBg})`}
          backgroundSize="cover"
          backgroundPosition="center"
          sx={imageZoomSx}
        />
        <Box position="absolute" top="8" left="8" color="white" zIndex="1">
          <Icon color="white" iconName={icon} boxSize={8} />
        </Box>
      </Box>

      {/* Content */}
      <CardBody p={8}>
        <VStack align="stretch" spacing={4}>
          <Heading
            size="lg"
            fontWeight="bold"
            color="text.darkBlue.900"
            letterSpacing="tight">
            {title}
          </Heading>
          <Text color="text.darkBlue.800" fontSize="md" lineHeight="tall">
            {description}
          </Text>
        </VStack>
      </CardBody>
    </Card>
  );
};
